import { render, staticRenderFns } from "./CantDeleteModal.vue?vue&type=template&id=f0463b8a&scoped=true&"
import script from "./CantDeleteModal.vue?vue&type=script&lang=js&"
export * from "./CantDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./CantDeleteModal.vue?vue&type=style&index=0&id=f0463b8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0463b8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VRow})
